import "../styles/main.scss";
import { loadContent, renderContent } from "./content";
import * as ui from "./ui";
import { createSpiral } from "./spiral";

document.documentElement.classList.add("js");

function fontsReady(): Promise<unknown> {
  if (!document.fonts?.ready) return Promise.resolve();
  return Promise.race([
    document.fonts.ready,
    new Promise<void>((r) => setTimeout(r, 1500)),
  ]);
}

async function boot(): Promise<void> {
  const data = await loadContent();
  renderContent(data);

  ui.initCursor();
  ui.initMagnetic();
  ui.initClock();
  const label = ui.initHoverLabel();

  await fontsReady();

  const items = data.spiral ?? [];
  let modal: ReturnType<typeof ui.initModal>;

  const spiral = createSpiral(
    document.querySelector<HTMLCanvasElement>("[data-spiral]"),
    {
      items,
      onHover: (item) => label.set(item),
      onSelect: (_item, i) => modal?.open(i),
    }
  );
  ui.setSpiral(spiral);

  modal = ui.initModal(items);
  const menu = ui.initMenu();
  const pages = ui.initPages(menu);
  const viewToggle = ui.initViewToggle(modal);

  // ── hehe easter egg ───────────────────────────────────────────────────────────────
  // click 5 times on logo quickly to play 67676767
  let eggTaps: number[] = [];
  let eggAudio: HTMLAudioElement | null = null;

  const triggerEgg = (): void => {
    const now = performance.now();
    eggTaps = eggTaps.filter((t) => now - t < 900).concat(now);
    if (eggTaps.length < 5) return;
    eggTaps = [];
    if (!eggAudio) {
      eggAudio = new Audio("./bondi-beach-late.m4a");
      eggAudio.volume = 0.85;
    }
    eggAudio.currentTime = 0;
    eggAudio.play().catch(() => {});
  };

  // ── handle logo click ───────────────────────────────────────────────────────────────
  document.querySelectorAll("[data-home]").forEach((homeEl) => {
    homeEl.addEventListener("click", (e) => {
      e.preventDefault();
      triggerEgg();
      menu.close();
      modal.close();
      document.querySelectorAll<HTMLElement>(".page.is-on").forEach((p) => pages.closePage(p));
      viewToggle.set("spiral");
    });
  });

  const ready = new Promise<string>((r) =>
    requestAnimationFrame(() => requestAnimationFrame(() => r("ready")))
  );
  ui.runLoaderIntro(ready, spiral);
}

boot().catch((e) => {
  console.error("[boot] failed", e); // FAH we are cooked if we get here
  document.querySelector(".loader")?.remove();
});
